import { render, staticRenderFns } from "./ChoiceField.vue?vue&type=template&id=aeefdea6&scoped=true"
import script from "./ChoiceField.vue?vue&type=script&lang=js"
export * from "./ChoiceField.vue?vue&type=script&lang=js"
import style0 from "./ChoiceField.vue?vue&type=style&index=0&id=aeefdea6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeefdea6",
  null
  
)

export default component.exports